import handleFetchErrors from '../utils/handleFetchErrors';
import { getAccessTokenFromLocalStorage } from '../utils/authHelpers';

const search360BaseUrl = process.env.REACT_APP_SEARCH360_HOST;

export function identityFetch() {
  return async ({ queryKey }: { queryKey: string[] }) => {
    const [uri, query] = queryKey;
    let url = `${search360BaseUrl}${uri}`;
    if (query) url = `${url}?${query}`;
    return fetch(url, {
      headers: { Authorization: `Bearer ${getAccessTokenFromLocalStorage()}` },
    })
      .then(handleFetchErrors)
      .then((res) => res.json());
  };
}

export function auditFetch() {
  return async ({ queryKey }: { queryKey: string[] }) => {
    const [uri, query] = queryKey;
    let url = `${search360BaseUrl}${uri}`;
    if (query) url = `${url}?${query}`;
    return fetch(url, {
      headers: { Authorization: `Bearer ${getAccessTokenFromLocalStorage()}` },
    })
      .then(handleFetchErrors)
      .then((res) => res.json());
  };
}

export async function updateUser(id: string, update: { roles: string[] }) {
  const url = `${search360BaseUrl}/identity/users/v1/${id}`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(update),
  })
    .then(handleFetchErrors)
    .then(() => update);
}

export async function createUser(data: Partial<Omit<User, '_id'>>) {
  const url = `${search360BaseUrl}/identity/users/v1`;
  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(handleFetchErrors);
}

export async function deleteUser(id: string) {
  const url = `${search360BaseUrl}/identity/users/v1/${id}`;
  return fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
      'Content-Type': 'application/json',
    },
  }).then(handleFetchErrors);
}
